<ng-container *ngTemplateOutlet="getTemplate()" />

<ng-template #longLabelTemplate>
  <span class="td-wb-account-group-label__description"
        [innerText]="accountGroup().businessLineDescription"></span>
  @if (accountGroup().groupNumber !== undefined) {
    <span>&nbsp;&ndash;&nbsp;</span>
  }
  <span class="td-wb-account-group-label__item"
        [innerText]="accountGroup().groupNumber"></span>
</ng-template>

<ng-template #shortLabelTemplate>
  <span class="td-wb-account-group-label__item"
        [innerText]="accountGroup().groupNumber"></span>
  @if (accountGroup().groupNumber !== undefined) {
    <span>&nbsp;&ndash;&nbsp;</span>
  }
  <span class="td-wb-account-group-label__description"
        [innerText]="accountGroup().accountTypeDescription">
  </span>
</ng-template>
